import { Pipe, PipeTransform } from '@angular/core';

import { getLocaleFromLang } from '../constants/constants';

@Pipe({ name: 'getLocaleFromLang' })
export class GetLocaleFromLangPipe implements PipeTransform {
  transform(lang?: string) {
    return getLocaleFromLang(lang);
  }
}
